module.exports = __webpack_public_path__ + "img/Background_green.c0953b24.png";